<template>
  <div style="font-family: -apple-system-font,PingFang SC,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel" :style="{ backgroundImage: `url(${detail.productBackground})`, backgroundSize: '100% 100%' }">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">{{ detail.caseTitle }}</div>
        <div class="case_time" v-if="detail.projectConstructionTime">
          <img src="../assets/images/developerCommunity/dev_time.png" alt="">
          <span>{{ detail.projectConstructionTime }}</span>
        </div>
        <hr>
      </div>
      <div class="case_detail">
        <div class="model" v-for="item in detail.contentList" :key="item.id" v-if="item.type">
          <div class="model_title" v-if="item.type === 'title' && item.title">{{ item.title }}</div>
          <div class="section" v-if="item.type === 'introduction' && item.introduction">
            {{ item.introduction }}
          </div>
          <div class="section" v-if="item.type === 'video' && item.video">
            <video style="width: 100%" muted loop controls>
              <source type="video/mp4" :src="item.video" />
            </video>
          </div>
          <div class="section" v-if="item.type === 'picture' && item.picture">
            <img :src="item.picture" alt="">
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import { detailCase } from '@/api'
export default {
  name: 'CaseZjnxhjjDetail',
  data () {
    return {
      detail: {}
    }
  },
  created () {
    this.getData()
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  methods: {
    async getData () {
      const res = await detailCase({ id: this.$route.query.id })
      this.detail = res.data
      console.log(res.data);
    },
  }
}
</script>

<style lang="scss">
.carousel {

  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #FFFFFF;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;
  min-height: 440px;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;

      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;

    img {
      width: 100%;
    }

    .model {
      margin-top: 0.2rem;

      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }

      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CaseDetailCommon.vue